/**
 * Pre-compiled localized messages for SplitButton component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import splitButtonMessages_en from "./intl/en";
import splitButtonMessages_de from "./intl/de";
import splitButtonMessages_es from "./intl/es";
import splitButtonMessages_fr from "./intl/fr-FR";
import splitButtonMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const splitButtonMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(splitButtonMessages_en),
  de: normalizeMessages(splitButtonMessages_de),
  es: normalizeMessages(splitButtonMessages_es),
  "fr-FR": normalizeMessages(splitButtonMessages_fr),
  "pt-BR": normalizeMessages(splitButtonMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for SplitButton component
 */
export type SplitButtonMessageKey = "noActionsAvailable";
